import { render, staticRenderFns } from "./yuyueSetting.vue?vue&type=template&id=511b7692&scoped=true&"
import script from "./yuyueSetting.vue?vue&type=script&lang=js&"
export * from "./yuyueSetting.vue?vue&type=script&lang=js&"
import style0 from "./yuyueSetting.vue?vue&type=style&index=0&id=511b7692&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511b7692",
  null
  
)

export default component.exports